import { render } from "./EventStausWidgetConfig.vue?vue&type=template&id=1d813962&scoped=true"
import script from "./EventStausWidgetConfig.vue?vue&type=script&lang=js"
export * from "./EventStausWidgetConfig.vue?vue&type=script&lang=js"

import "./EventStausWidgetConfig.vue?vue&type=style&index=0&id=1d813962&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d813962"],['__file',"src/containers/widget/configs/EventStausWidgetConfig.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d813962"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d813962', __exports__)) {
    api.reload('1d813962', __exports__)
  }
  
  module.hot.accept("./EventStausWidgetConfig.vue?vue&type=template&id=1d813962&scoped=true", () => {
    api.rerender('1d813962', render)
  })

}


export default __exports__